import { useEffect, useRef, useState } from "react";

export const useInView = (options = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -80px 0px", ...options }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
};

export const revealClass = (inView, delay = 0) => ({
  style: {
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(40px)",
    transition: `opacity 0.9s cubic-bezier(0.2,0.7,0.2,1) ${delay}s, transform 0.9s cubic-bezier(0.2,0.7,0.2,1) ${delay}s`,
  },
});
